import { FormField } from '@domgen/dgx-fe-forms/layout';

export interface CmsApplianceDetailsModelSerialForm {
  modelNumberField: FormField;
  serialNumberField: FormField;
}
